import api from "@/services/api";
import axios from "axios";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export default {
  fetchStakeholders() {
    return api.get(`stakeholders/`).then(response => response.data);
  },
  stakeholderLookUp(payload) {
    return api.post(`stakeholders/look_up_stakeholder/`, payload);
  },
  updateStakeholder(payload) {
    return api.patch(`stakeholders/${payload.pk}/`, payload);
  },
  getToken() {
    return axios.get(process.env.VUE_APP_ARCGIS_TOKEN_URL, {
      params: {
        client_id: process.env.VUE_APP_ARCGIS_ID,
        grant_type: "client_credentials",
        client_secret: process.env.VUE_APP_ARCGIS_SECRET,
        f: "pjson"
      }
    });
  },
  createGeocode(payload) {
    return this.getToken()
      .then(response => {
        const accessToken = response.data.access_token;
        const address = {
          records: [{
            attributes: {
              OBJECTID: 1,
              Address: payload.address,
              City: payload.city,
              Region: payload.state,
              Postal: payload.postal_code
            }
          }]
        };

        const formattedAddress = encodeURI(JSON.stringify(address));
        const url = `${process.env.VUE_APP_ARCGIS_GEOCODE_URL}addresses=${formattedAddress}`

        return axios.get(url, {
          timeout: 5000,
          params: {
            forStorage: true,
            token: accessToken,
            f: "pjson"
          }
        })
          .then(response => {
            return response.data.locations[0];
          })
          .catch(() => {
            return this.alternativeGeocode(payload)
              .then(response => {
                return response
              })
          })
      })
  },
  alternativeGeocode(payload) {
    const address = (payload.address || "");
    const city = (payload.city || "");
    const state = (payload.state || "");
    const postal = (payload.postal_code || "");

    const formattedAddress = `${address} ${city} ${state} ${postal}`
    return axios.get(process.env.VUE_APP_OPENCAGE_GEOCODE_URL, {
      timeout: 5000,
      params: {
        q: formattedAddress,
        key: process.env.VUE_APP_OPENCAGE_KEY
      }
    })
      .then(response => {
        const coordinates = {
          location: {
            x: response.data.results[0].geometry.lng,
            y: response.data.results[0].geometry.lat
          }
        }
        return coordinates
      })
      .catch(error => {
      /* eslint-disable */
      console.log(error);
      /* eslint-enable */
        return "unavailable"
      });
  },
  emailAllStakeholders(payload) {
    return api.post(`stakeholders/send_emails/`, payload);
  },
  postStakeholder(payload) {
    return api.post(`stakeholders/`, payload);
  },
  inviteStakeholderToConversation(payload) {
    return api.post(
      `stakeholders/invite_stakeholder_to_conversation/`,
      payload
    );
  },
  notifyStakeholder(payload) {
    return api.post(`stakeholders/notify_stakeholder/`, payload);
  },
  getStakeholderNames() {
    return api.get(`stakeholders/get_stakeholder_names`)
  }
};
